import {httpsCallable} from 'firebase/functions';
import {functions} from './firebase';

export interface ReplySuggestionResult {
    suggestion: string;
}

/**
 * Génère une suggestion de réponse pour un message du support.
 *
 * Les connaissances produit viennent du back-office (endpoint /aiFactApi/facts), qui est la
 * source unique partagée avec les réponses aux avis stores : un fait corrigé dans le BO
 * s'applique aussi ici, sans redéploiement.
 *
 * La génération prend souvent une minute ou plus — d'où le timeout relevé.
 */
export async function suggestFeedbackReply(feedbackId: string): Promise<string> {
    const suggestFn = httpsCallable<{ feedbackId: string }, ReplySuggestionResult>(
        functions,
        'suggestFeedbackReply',
        {timeout: 300000}
    );
    const result = await suggestFn({feedbackId});
    return result.data.suggestion;
}
